export type StatusSolicitacao =
  | 'Solicitação Recebida'
  | 'Em Análise'
  | 'Vistoria Agendada'
  | 'Vistoria Realizada'
  | 'Aprovada'
  | 'Reprovada'
  | 'Aguardando Replantio'
  | 'Processo Concluído'

export const STATUS_LIST: StatusSolicitacao[] = [
  'Solicitação Recebida',
  'Em Análise',
  'Vistoria Agendada',
  'Vistoria Realizada',
  'Aprovada',
  'Reprovada',
  'Aguardando Replantio',
  'Processo Concluído',
]

export const STATUS_COLORS: Record<StatusSolicitacao, string> = {
  'Solicitação Recebida':  'bg-blue-50 text-blue-700 border-blue-200',
  'Em Análise':            'bg-yellow-50 text-yellow-700 border-yellow-200',
  'Vistoria Agendada':     'bg-purple-50 text-purple-700 border-purple-200',
  'Vistoria Realizada':    'bg-indigo-50 text-indigo-700 border-indigo-200',
  'Aprovada':              'bg-green-50 text-green-700 border-green-200',
  'Reprovada':             'bg-red-50 text-red-700 border-red-200',
  'Aguardando Replantio':  'bg-orange-50 text-orange-700 border-orange-200',
  'Processo Concluído':    'bg-gray-100 text-gray-700 border-gray-300',
}

export type EstadoArvore =
  | 'Saudável'
  | 'Doente'
  | 'Morta'
  | 'Risco de Queda'
  | 'Danificando Estrutura'

export interface Bairro {
  _id: string
  nome: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Rua {
  _id: string
  nome: string
  bairroId: string
  bairroNome: string
  creator: string
  createdAt: string
  updatedAt: string
}


export interface Configuracao {
  _id: string
  nomePrefeitura: string
  cnpj?: string
  endereco?: string
  bairro?: string
  cidade?: string
  cep?: string
  telefone?: string
  email?: string
  logoUrl?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface AssinaturaSolicitante {
  nome: string
  cpf: string
  dataUrl: string
}

export interface AssinaturaSecretario {
  nome: string
  cargo: string
  dataUrl: string
}

export interface Solicitacao {
  _id: string
  protocolo: string
  origem?: 'interno' | 'online'
  nomeCompleto: string
  cpf: string
  telefone: string
  endereco?: string
  bairroId?: string
  bairroNome: string
  ruaId?: string
  ruaNome: string
  numero: string
  pontoReferencia?: string
  tipoArvore: string
  quantidadeArvores: number
  alturaAproximada?: string
  porte?: 'Pequeno' | 'Médio' | 'Grande'
  coordenadas?: string
  estadoArvore: EstadoArvore
  seraSubstituida: boolean
  qualArvoreReplantio?: string
  localReplantio?: string
  ondeReplantio?: string
  motivoNaoSubstituicao?: string
  relatoProblema: string
  fotos?: string[]
  documentos?: string[]
  termoAceito: boolean
  // Assinaturas — apenas solicitante e responsável técnico na solicitação
  assinaturasSolicitante?: { nome: string; cpf: string }
  assinaturasSecretario?: { cargo: string }
  status: StatusSolicitacao
  // Finalização
  finalizado?: boolean
  dataFinalizacao?: string
  pdfAssinadoUrl?: string
  observacaoFinalizacao?: string
  // Dados do replantio (preenchidos na conclusão)
  arvoreReplantada?: string
  tipoArvoreReplantada?: string
  enderecoReplantio?: string
  dentroDoPrezo?: boolean
  observacaoReplantio?: string
  // Registo de replantio efectivo (área de replantio do admin)
  replantioRegistado?: boolean
  replantioData?: string
  replantioResponsavel?: string
  replantioEndereco?: string
  replantioTipoArvore?: string
  replantioFotos?: string[]
  // Prazo definido para o cidadão realizar o replantio (usado no Alerta WhatsApp)
  prazoReplantio?: string
  // Cancelamento do replantio (com justificativa visível ao cidadão no Portal)
  replantioCancelado?: boolean
  replantioCanceladoJustificativa?: string
  replantioCanceladoData?: string
  // Parecer Técnico — salvo após emissão
  parecerEmitido?: boolean
  parecerData?: string
  parecerDados?: import('@/utils/gerarParecerTecnico').DadosParecer
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Catador {
  _id: string
  nomeCompleto: string
  cpf: string
  telefone: string
  rua: string
  numero: string
  bairro: string
  cep: string
  cidade: string
  fotoUrl?: string
  tiposReciclados: string[]
  observacoes?: string
  ativo: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface HistoricoStatus {
  _id: string
  solicitacaoId: string
  protocolo: string
  status: string
  responsavel: string
  observacoes?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface UsuarioSistema {
  _id: string
  userId: string
  userName: string
  email: string
  cargo: string
  ativo: boolean
  userRole?: 'ADMIN' | 'USER'
  creator: string
  createdAt: string
  updatedAt: string
}
